// extracted by mini-css-extract-plugin
export default {"bar_text":"styles_bar_text__VsyVG","bar_text-mini":"styles_bar_text-mini__2FphW"};